import { render } from "./ImageLoaderOverlay.vue?vue&type=template&id=1121c7a7&scoped=true&ts=true"
import script from "./ImageLoaderOverlay.vue?vue&type=script&lang=ts"
export * from "./ImageLoaderOverlay.vue?vue&type=script&lang=ts"

import "./ImageLoaderOverlay.vue?vue&type=style&index=0&id=1121c7a7&lang=scss&scoped=true"

import exportComponent from "/home/production/domains/monteur.waterluxe.nl/monteur-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1121c7a7"]])

export default __exports__